import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-471737bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-content-between category-card" }
const _hoisted_2 = { class: "flex flex-column justify-content-end" }
const _hoisted_3 = {
  key: 0,
  class: "flex"
}
const _hoisted_4 = { class: "flex app-label-small font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.count !== undefined)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.count), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.label), 1)
    ]),
    _createElementVNode("i", {
      class: _normalizeClass(_ctx.iconClass)
    }, null, 2)
  ]))
}